import fullpage from 'fullpage.js'
import velocity from 'velocity-animate';

import './index.scss';

class App {
  constructor() {

    this.mainContainer = $('#fullpage');
    // this.header = $('.header');

    this.initPage();
  }

  initPage() {
    this.mainContainer.fullpage({
      menu: '#menu',
      navigation: true,
      navigationPosition: 'right',
      navigationTooltips: ['01', '02', '03', '04', '05'],
      showActiveTooltip: true,
      // scrolling
      css3: true,
      scrollingSpeed: 1000,
      // design
      controlArrows: false,
      responsiveWidth: 767,
      fadingEffect: true,
      // custom selectors
      sectionSelector: 'section',
      lazyLoading: true,
      fixedElements: '.header, footer',
      /*
      afterLoad: function(anchorLink, index){
        //$('#header').removeClass().addClass(anchorLink + '-sec');

        //velocity.animate(document.getElementById('swainby-title'), 'reverse', 200);
      },
      onLeave (index, nextIndex, direction){
        //velocity.animate(document.getElementById('swainby-title'), { opacity: 0.1 }, 500);
      },
      */
    });
  }
}

new App();



// WEBPACK FOOTER //
// ./src/swainby/index.js